import React from 'react';
import BlogList from '../components/BlogList';
import UniqueBanner from "../components/UniqueBanner";
import BannerImg from "../assets/Institute/GIRI7947.JPG";
import NttCourseAdmission from "../assets/Institute/Ntt-Course-Admission.jpeg";
import Institute from "../assets/Institute/DSC_3717.JPG";
import AspiringEducators from "../assets/Institute/AspiringEducators.jpg";
import ValueAdded from "../assets/Institute/ValueAdded.jpeg";

const Blogs = () => {
const posts = [
  {
    image: NttCourseAdmission,
    title: "Discover Teacher Training Programs for Educators",
    description:
      "Embarking on a teaching career is like setting sail on a journey...",
    readTime: 4,
    views: 10,
    likes: 20,
    link: "/post/discover-teacher-training-programs-for-educators",
    category: "",
  },

  {
    image: Institute,
    title: "NIECCE Bengaluru: Leading Teacher Training Institute",
    description:
      "Starting a career in early childhood or primary education is rewarding...",
    readTime: 4,
    views: 6,
    likes: 20,
    link: "/post/niecce-bengaluru-leading-teacher-training-institute",
    category: "",
  },

  {
    image: AspiringEducators,
    title: "Nursery Teacher Training for Aspiring Educators",
    description:
      "Starting a career in early childhood education is both exciting and rewarding.",
    readTime: 3,
    views: 4,
    likes: 30,
    link: "/post/nursery-teacher-training-for-aspiring-educators",
    category: "",
  },

  {
    image: ValueAdded,
    title:
      "Unlocking the Power of Phonics: NIECCE's Value-Added Phonics Program",
    description:
      "At the National Institute of Early Childhood Care and Education (NIECCE)...",
    readTime: 2,
    views: 74,
    likes: 40,
    link: "/post/unlocking-the-power-of-phonics-niecce-phonics-program",
    category: "",
  },

  {
    image:
      "https://static.wixstatic.com/media/6870b3_87f91d3ef9e84400ae216593e3b97116~mv2.jpg/v1/fill/w_1414,h_1062,fp_0.50_0.50,q_90,enc_avif,quality_auto/6870b3_87f91d3ef9e84400ae216593e3b97116~mv2.jpg",
    title:
      "Business Icon 2022 – Best Teacher Training Program Award by Murugesh Nirani",
    description:
      "We are happy to announce that we were awarded the Business Icon of the Year 2022...",
    readTime: 2,
    views: 227,
    likes: 30,
    link: "/post/business-icon-2022-best-teacher-training-program-award",
    category: "",
  },

  {
    image:
      "https://static.wixstatic.com/media/6870b3_934d7e9513a342778eb4d86c3e453779~mv2.jpg/v1/fill/w_1414,h_1062,fp_0.50_0.50,q_90,enc_avif,quality_auto/6870b3_934d7e9513a342778eb4d86c3e453779~mv2.jpg",
    title: "Book Launch of Lil Beez – Early Childhood Learning Series",
    description:
      "We are proud to announce that our first series of Lil Beez books ...",
    readTime: 2,
    views: 333,
    likes: 50,
    link: "/post/book-launch-lil-beez-early-childhood-learning-series",
    category: "",
  },

  {
    image:
      "https://static.wixstatic.com/media/6870b3_1837f82ba8ec440bb4cb73b14334ac7e~mv2.jpg/v1/fill/w_1816,h_1364,fp_0.50_0.50,q_90,enc_avif,quality_auto/6870b3_1837f82ba8ec440bb4cb73b14334ac7e~mv2.jpg",
    title:
      "Importance of Value-Added Programs in Teacher Training Programs",
    description:
      "Besides the regular tidbits of the learning module and the program course ...",
    readTime: 2,
    views: 452,
    likes: 280,
    link: "/post/importance-of-value-added-programs-in-teacher-training",
    category: "Teacher Resources",
  },

  {
    image:
      "https://static.wixstatic.com/media/6870b3_2f2a6c08b3974af8871ea2e950419fbe~mv2.jpg/v1/fill/w_1816,h_1364,fp_0.50_0.50,q_90,enc_avif,quality_auto/6870b3_2f2a6c08b3974af8871ea2e950419fbe~mv2.jpg",
    title: "Welcome to NIECCE Teacher's Journal",
    description:
      "Let me introduce myself, I am Keertish. I am a Business Grad., a Pharmacist, A qualified ...",
    readTime: 1,
    views: 100,
    likes: 61,
    link: "/post/welcome-to-niecce-teachers-journal",
    category: "NIECCE News & Updates",
  },
];

  return (
    <>
    <UniqueBanner
  image={BannerImg}
  title="Insights & Updates"
  subtitle="Explore articles, tips, and news on early childhood education"
/>
    <BlogList posts={posts} />
    </>
  );
};

export default Blogs;
